import './style/index.js';

import _Checkbox from './Checkbox';

export type { CheckboxProps } from './Checkbox';
export type { CheckboxGroupProps } from './CheckboxGroup';
export * from './type';

export const Checkbox = _Checkbox;
export default Checkbox;
